import { render, staticRenderFns } from "./life-insurance-form.html?vue&type=template&id=7abc2676&scoped=true&"
import script from "./life-insurance-form.js?vue&type=script&lang=js&"
export * from "./life-insurance-form.js?vue&type=script&lang=js&"
import style0 from "./life-insurance-form.scss?vue&type=style&index=0&id=7abc2676&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abc2676",
  null
  
)

export default component.exports